export default __webpack_public_path__ + "static/media/rest-assured.7ec4f08b.svg";